import ApiClient from 'api-client/ApiClient'
import ActionsSet from 'core/actions/ActionsSet'
import ListAction from 'core/actions/ListAction'
import DataKeys, { entityNamesByKey } from 'k8s/DataKeys'
import Bugsnag from 'utils/bugsnag'

const { kubernetes } = ApiClient.getInstance()

export const kaapiKubeadmControlPlaneActions = ActionsSet.make<DataKeys.KaapiKubeadmControlPlanes>({
  uniqueIdentifier: 'metadata.uid',
  entityName: entityNamesByKey[DataKeys.KaapiKubeadmControlPlanes],
  cacheKey: DataKeys.KaapiKubeadmControlPlanes,
})

export const listKaapiKubeadmControlPlanes = kaapiKubeadmControlPlaneActions
  .add(
    new ListAction<DataKeys.KaapiKubeadmControlPlanes>(async ({ namespace }) => {
      Bugsnag.leaveBreadcrumb('Attempting to get Kaapi KubeadmControlPlanes', { namespace })
      return kubernetes.getAllCustomResources(DataKeys.KaapiKubeadmControlPlanes)
    }),
  )
  .addDependency(DataKeys.KaapiOpenStackMachineTemplates)
  .addDependency(DataKeys.KaapiOpenStackServers)
